import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import InfoLayout from "../components/landing/InfoLayout";

const NotFound = () => {
  return (
    <InfoLayout
        title="Página no encontrada - MiQRapp"
        description="La página o el catálogo que buscás no existe en MiQRapp."
        narrow
        eyebrow="Error 404"
        heading="No encontramos esta página"
        subheading="Puede que el link esté mal escrito o que el catálogo que buscás ya no exista."
    >
        <section className="lp-section lp-info-body">
            <div className="lp-container lp-faq-page">
                <div className="lp-info-cta lp-hero-intro">
                    <div>
                        <h2>¿Buscabas un catálogo?</h2>
                        <p>Revisá el link o pedile al negocio que te pase su QR de nuevo.</p>
                    </div>
                    <div className="lp-info-cta-actions">
                        <HashLink to="/#planes" smooth className="lp-btn lp-btn-secondary">Ver planes</HashLink>
                        <Link to="/" className="lp-btn lp-btn-primary">Volver al inicio</Link>
                    </div>
                </div>
            </div>
        </section>
    </InfoLayout>
  )
}

export default NotFound
